document.addEventListener("DOMContentLoaded", function () {

  // ENTREGA EXPRESSA
  const entrega = document.querySelector("[data-entrega]");
  if (entrega) {
    entrega.addEventListener("click", function () {
      document.dispatchEvent(new CustomEvent("abrirEntregaExpressa"));
    });
  }

  // WHATSAPP (ABRIR POPUP)
document.addEventListener("click", function (e) {

  const card = e.target.closest("[data-whatsapp]");
  if (!card) return;

  const tryClick = () => {
    const btn = document.querySelector(".btn-whatsapp");
    if (btn) {
      btn.click();
      return true;
    }
    return false;
  };

  // tenta imediatamente
  if (tryClick()) return;

  // tenta novamente por até 2s (caso carregue depois)
  let tentativas = 0;
  const intervalo = setInterval(() => {
    if (tryClick() || tentativas > 20) {
      clearInterval(intervalo);
    }
    tentativas++;
  }, 100);

});

});


// SETAS MOBILE
document.addEventListener("DOMContentLoaded", function () {

  const container = document.querySelector(".beneficios");
  const cards = document.querySelectorAll(".beneficio-card");
  const left = document.querySelector(".beneficios-arrow--left");
  const right = document.querySelector(".beneficios-arrow--right");

  if (!container || !cards.length) return;

  // 🔥 pega largura real do card + gap
  function getStep() {
    const card = cards[0];
    const style = window.getComputedStyle(container);
    const gap = parseInt(style.columnGap || style.gap || 0);
    return card.offsetWidth + gap;
  }

  function updateArrows() {
    const maxScroll = container.scrollWidth - container.clientWidth;

    if (container.scrollLeft <= 10) {
      left?.classList.add("hidden");
    } else {
      left?.classList.remove("hidden");
    }

    if (container.scrollLeft >= maxScroll - 10) {
      right?.classList.add("hidden");
    } else {
      right?.classList.remove("hidden");
    }
  }

  left?.addEventListener("click", () => {
    container.scrollBy({
      left: -getStep(),
      behavior: "smooth"
    });
  });

  right?.addEventListener("click", () => {
    container.scrollBy({
      left: getStep(),
      behavior: "smooth"
    });
  });

  container.addEventListener("scroll", () => {
    requestAnimationFrame(updateArrows);
  });

  window.addEventListener("resize", updateArrows);

  // 🔥 reset inicial correto
  container.scrollLeft = 0;

  setTimeout(updateArrows, 100);
});